/**
 * Which pills of a row fit beside its caret button, as WhatsApp Web's filter row: the row never
 * scrolls, the pills that do not fit go to the caret's menu, and the chosen one always shows (it
 * takes the last place when it would not fit where it is). Indexes keep the original order.
 */
export function fitTabs(input: {
  widths: number[];
  /** Index of the chosen pill, -1 when none. */
  active: number;
  /** The row's inner width. */
  room: number;
  gap: number;
  /** The caret button's width. */
  more: number;
  /** The caret shows even when every pill fits (it holds "New tag"). */
  alwaysMore?: boolean;
}): { shown: number[]; hidden: number[] } {
  const { widths, active, room, gap, more } = input;
  const all = widths.map((_, i) => i);
  const width = (ids: number[]) =>
    ids.reduce((sum, i) => sum + widths[i]!, 0) +
    Math.max(0, ids.length - 1) * gap;
  // Not laid out yet (a hidden panel): show everything rather than nothing.
  if (room <= 0) return { shown: all, hidden: [] };
  if (!input.alwaysMore && width(all) <= room)
    return { shown: all, hidden: [] };
  const space = room - more - gap;
  let count = 0;
  while (count < widths.length && width(all.slice(0, count + 1)) <= space)
    count++;
  let shown = all.slice(0, count);
  if (active >= count && active < widths.length) {
    let keep = count;
    while (keep > 0 && width([...all.slice(0, keep), active]) > space) keep--;
    shown = [...all.slice(0, keep), active];
  }
  return { shown, hidden: all.filter((i) => !shown.includes(i)) };
}
